import { defineMessage } from 'react-intl'

export const charCountMessage = defineMessage({
  id: 'P/skwL9Ntd',
  defaultMessage: '{current}/{max}',
  description: 'Character count showing current length out of maximum allowed characters',
})

export const parenthesisedCountMessage = defineMessage({
  id: 'ooQ51lslOq',
  defaultMessage: '({count})',
  description: 'Count displayed in parentheses, e.g. next to a filter option or button',
})

export const perAdultMessage = defineMessage({
  id: 'f2dAyH4b+A',
  defaultMessage: '/adult',
  description: 'Per adult price suffix',
})
